export enum FeParamsPage {
  FareEstimateResults = 'FareEstimateResults',
  OrderReview = 'OrderReview',
}
